<div class="personal-info-complete-container">

  <img alt="personal info complete" src="/img/personal-info-complete.png">

  <div class="text header">
    <span [innerHTML]="'PersonalInfoComplete.Title' | translate | safe:'html'"></span>
  </div>

  <div [innerHTML]="'PersonalInfoComplete.SubTitle' | translate | safe:'html'" class="text">
  </div>

</div>
